"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ChallengeType_1 = require("../../enums/ChallengeType");
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const ElementIds_1 = require("../../enums/ElementIds");
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'one-time-code',
    data: () => {
        return {
            resendingCode: false,
            canResendCode: true,
        };
    },
    props: {
        authenticationFactor: {
            type: String,
            required: true,
        },
        oneTimeCode: {
            type: String,
            default: '',
        },
    },
    computed: {
        tokenLength() {
            if (this.authenticationFactor === AuthenticationFactor_1.AuthenticationFactor.Token)
                return 8;
            return 6;
        },
        subHeadingText() {
            let type = '';
            let replace = [];
            switch (this.authenticationFactor) {
                case AuthenticationFactor_1.AuthenticationFactor.SmsCode:
                case AuthenticationFactor_1.AuthenticationFactor.VoiceCode:
                    type = 'Phone';
                    replace = [this.currentChallenge.Destination.MaskedAddress];
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.EmailCode:
                    type = 'Email';
                    replace = [this.currentChallenge.Destination.MaskedAddress];
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.Token:
                    type = 'Token';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                    type = 'TOTP';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.Unknown:
                    type = 'Unknown';
                    break;
            }
            return this.getSiteText(`Forgot.VerificationCode.SubHeading.${type}`, replace);
        },
        actionText() {
            return this.isMobile ? '' : this.getSiteText('Forgot.VerificationCode.EnterCode');
        },
        hasError() {
            return (this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        errorText() {
            return this.getSiteText(`ChallengeStatus.${this.$store.state.challengeStatus}`);
        },
        inputHelperText() {
            let type = '';
            let replace = [];
            switch (this.authenticationFactor) {
                case AuthenticationFactor_1.AuthenticationFactor.SmsCode:
                case AuthenticationFactor_1.AuthenticationFactor.VoiceCode:
                case AuthenticationFactor_1.AuthenticationFactor.EmailCode:
                    type = 'Expiration';
                    replace = [this.currentChallenge.MinutesToLive.toString()];
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.Token:
                    type = 'Token';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                    type = 'TOTP';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.Unknown:
                    type = 'Unknown';
                    break;
            }
            return this.getSiteText(`Forgot.VerificationCode.HelperText.${type}`, replace);
        },
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        displayResendCode() {
            switch (this.authenticationFactor) {
                case AuthenticationFactor_1.AuthenticationFactor.SmsCode:
                case AuthenticationFactor_1.AuthenticationFactor.VoiceCode:
                case AuthenticationFactor_1.AuthenticationFactor.EmailCode:
                    return true;
            }
            return false;
        },
        resendButtonText() {
            return this.canResendCode ?
                this.getSiteText('Forgot.VerificationCode.ResendCode') :
                this.getSiteText('Forgot.VerificationCode.CodeSent');
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        authenticatedModel() {
            return this.$store.getters.authenticatedModel;
        },
        isSyncing() {
            return this.$store.getters.isSyncing;
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        oneTimeCodeUpdated(value) {
            // Clear any errors when user starts typing in a new code
            if (this.hasError)
                this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            this.$emit('code-entered', {
                valid: value.length === this.tokenLength,
                code: value,
            });
        },
        async resendCode() {
            if (this.resendingCode) {
                return;
            }
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.verification_code,
                    action: userTelemetry_1.userAction.resend_code_clicked,
                });
            }
            this.resendingCode = true;
            // update is resending OTP property
            this.$store.commit('setIsResendingOTP', this.resendingCode);
            const challenge = {
                ...this.currentChallenge,
                ChallengeTypeValue: ChallengeType_1.ChallengeType.OneTimeCodeDestination,
            };
            await this.$store.dispatch('submitChallenge', challenge);
            this.resendingCode = false;
            // update after code is sent
            this.$store.commit('setIsResendingOTP', this.resendingCode);
            // reset code after resending it, disable the resend button and create timer to enable it after 1 minute
            this.oneTimeCodeUpdated('');
            this.canResendCode = false;
            setTimeout(() => this.canResendCode = true, 60000);
        },
        changeMethod() {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.verification_code,
                    action: userTelemetry_1.userAction.change_method_clicked,
                });
            }
            // switch the challengeStatus to unknown to clear any OTP failed message when changing method
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            this.$emit('change-stepup-method');
        },
    },
    watch: {
        async isSyncing() {
            while (this.$store.getters.isSyncing && !this.authenticatedModel.username.length) {
                const challenge = {
                    ...this.$store.getters.checkSyncResultChallenge,
                };
                await this.$store.dispatch('submitChallenge', challenge);
                await new Promise((r) => setTimeout(r, 1000));
            }
        },
        authenticatedModel(newAuthenticatedModel) {
            if (newAuthenticatedModel && typeof newAuthenticatedModel.username == 'string' && typeof newAuthenticatedModel.nonce == 'string') {
                this.$nextTick(() => {
                    const formElement = document.querySelector('#form_authenticated');
                    if (formElement) {
                        this.$store.commit('setIsSubmittingAuthenticatedModel', true);
                        formElement.submit();
                    }
                });
            }
        },
    },
});
